<div class="new-mail-subscribers">
    <div class="main-mail-subscriber">
        <div class="dialog-title-row">
            <h1 class="title-mail-subscriber m-0">Comunicación para todos los usuarios</h1>
            <button class="btn-close-dialog" mat-dialog-close><i class="fa-light fa-times"></i></button>
        </div>
        <p class="subtitle-mail-subscriber">Ingresa los datos del email que
            recibirán todos los usuarios suscritos.</p>
        <div class="form-info-user">
            <form class="form-grid" [formGroup]="emailSubscription">
                <div class="m-2">
                    <p class="label-input">Asunto</p>
                    <div class="form-input-container"
                        [ngClass]="{'error-border': emailSubscription.get('subject')?.invalid && emailSubscription.get('subject')?.touched}">
                        <input type="text" class="w-100"
                            formControlName="subject">
                    </div>
                    <span class="error-msg"
                        [class.visible]="emailSubscription.get('subject')?.hasError('maxlength') && emailSubscription.get('subject')?.touched">
                        Límite de 200 caracteres excedido.
                    </span>
                </div>
                <div class="m-2">
                    <p class="label-input">Adjuntos</p>
                    <div class="form-input-container btn-upload">
                        <!-- Permitir múltiples archivos -->
                        <input id="file" hidden #file type="file"
                            (change)="onFileChange($event)" multiple
                            accept=".pdf, application/pdf">
                        <div class="btn-create m-0" (click)="file.click()">
                            <i class="fal fa-arrow-up-from-bracket"></i>
                            <p class="m-0">Subir archivos</p>
                        </div>
                    </div>
                    <div class="name-file-upload" *ngIf="files.length > 0">
                        <ul>
                            <li class="file-item" *ngFor="let file of files; let i = index">
                                <span class="file-name">{{file.name}}</span>
                                <i class="fal fa-xmark btn-remove-file" (click)="removeFile(i)"></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="m-2 mt-4">
                    <p class="label-input">Mensaje</p>
                    <div
                        [ngClass]="{'editor-error': emailSubscription.get('body')?.invalid && emailSubscription.get('body')?.touched}">
                        <angular-editor #edit id="1" formControlName="body"
                            [config]="editorConfig"></angular-editor>
                    </div>
                    <span class="error-msg"
                        [class.visible]="emailSubscription.get('body')?.hasError('maxlength') && emailSubscription.get('body')?.touched">
                        Límite de 5000 caracteres excedido.
                    </span>
                </div>
            </form>
        </div>
    </div>
    <div class="footer-dialog-comunication">
        <mat-divider></mat-divider>
        <div class="footer-new-subscriber">
            <div class="btn-new btn-create m-0" [class.sending]="emailSend"
                (click)="sendEmail()"
                [class.disabled]="emailSubscription.invalid || isSizeExceeded">
                <p class="m-0">{{emailSend ? 'Enviando...' : 'Aceptar'}}</p>
            </div>
        </div>
    </div>
</div>